module.exports = __webpack_public_path__ + "img/U.LULogo_top_new.a44cebb6.png";